import {getAllSubstanceLists} from "@core/domain/substance";

export default {
    methods: {
        activeSubstanceLists(lists, legislations) {
            if (legislations.length === 0) {
                return lists;
            }

            lists = lists.filter(l => l.key !== 'empty');

            const idListMap = {};
            lists.forEach(l => idListMap[l.getId()] = l);

            //  take lists only for active legislations
            const filtered = lists.filter(l => l.hasIntersectionWithLegislations(legislations));

            //  check referencing lists
            const idList = filtered.map(l => l.id);
            filtered
                .filter(l => l.hasReferencingLists())
                .forEach(l => {
                    l.getReferencingLists().forEach(listId => {
                        if (!idList.includes(listId)) {
                            idList.push(listId);
                            filtered.push(idListMap[listId]);
                        }
                    });
                });

            return filtered;
        }
    }
};
